<template>
  <div>
    
    <br />
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="Code">Account No:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.custCode"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="Name">Name:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.custName"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="Branch">Main MBP Branch:</label>
        <InputText
          class="clearer"
          v-if="customer1.mbpBranch"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.mbpBranch.branchName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="address2">Type:</label>
        <InputText
          class="clearer"
          v-if="customer1.customerType"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.customerType.typeName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="address4">Region:</label>
        <InputText
          class="clearer"
          v-if="customer1.region"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.region.regionName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="salesExec">Sales Exec:</label>
        <InputText
          class="clearer"
          v-if="customer1.salesExec"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.salesExec.salesExecName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="address">Address:</label>
        <Textarea
          class="clearer"
          placeholder=""
          :disabled="true"
          :autoResize="true"
          rows="7"
          v-model="customer1.address"
        />
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="customer">Phone:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.phoneNo"
        ></InputText>
        <label for="contact">Mobile:</label>
        <InputText
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.mobile"
        ></InputText>
        <label for="rcvdDate">Fax:</label>
        <InputText
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.fax"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="branch">Email:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.mainEmail"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="projectType">Website:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.website"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="highlight p-field p-col-6 p-md-6">
        <label for="opportunityStatus">Key Contact:</label>

        <div class="highlight p-inputgroup">
          <input 
            v-if="customer1.keyContact"
            type="text" 
            class="keyContactInput" 
            id="keyContactFullName" 
            placeholder="Key contact"
            v-model.trim="customer1.keyContact.contactName"
            required="false"
            disabled="true"
          >
          <InputText
            v-else
            type="text"
            placeholder=""
            :disabled="true"
          ></InputText>
          <Button
            icon="pi pi-plus"
            class="p-button-rounded p-button-info p-button-text"
            @click="openModalContact"
          />
          <Button
            icon="pi pi-user"
            class="p-button-rounded p-button-success p-button-text"
            @click="toggle"
            aria:haspopup="true"
            aria-controls="overlay_panel"
          />
          <OverlayPanel
            ref="op"
            @click="toggle"
            appendTo="body"
            :showCloseIcon="true"
            id="overlay_panel"
            style="width: 600px"
          >
            <!-- v-model -->
            <DataTable
              :value="contacts"
              :selection.sync="selectedContact"
              :rowHover="true"
              selectionMode="single"
              dataKey="contactId"
              :paginator="false"
              :rows="5"
              @row-select="onProductSelect"
            >
              <template #empty> No contacts found! </template>
              <template #loading> Loading Contacts. Please wait. </template>
              <Column field="name" header="Name" sortable>
                <template #body="slotProps">
                  {{ slotProps.data.contactName }}
                </template>
              </Column>
              <Column header="Job Title" field="jobTitle.jobTitleDesc">
                <template #body="slotProps">
                  <span v-if="slotProps.data.jobTitle">
                    {{ slotProps.data.jobTitle.jobTitleDesc }}
                  </span>
                  <span v-else> - </span>
                </template>
              </Column>
              <Column field="email" header="Email" sortable>
                <template #body="slotProps">
                  {{ slotProps.data.email ? slotProps.data.email : "" }}
                </template>
              </Column>
            </DataTable>
            <div>
              <Button
                style="float: right; margin: 10px"
                label="Save"
                icon="pi pi-check"
                class="p-button-text"
                @click="updateContact"
              />
            </div>
          </OverlayPanel>
        </div>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="phoneNo">Tags:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.tags"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="email">Show Msg:</label>
        <Textarea
          class="clearer"
          placeholder=""
          :disabled="true"
          :autoResize="true"
          rows="3"
          v-model="customer1.showMsg"
        />
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="salesExec">Main Notes:</label>
        <Textarea
          class="clearer"
          placeholder=""
          :disabled="true"
          :autoResize="true"
          rows="3"
          v-model="customer1.mainNotes"
        />
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="createdBy">Created By:</label>
        <InputText
          class="clearer"
          v-if="customer1.createdBy"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.createdBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="created">Date Created:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.dateCreated"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="updatedBy">Updated By:</label>
        <InputText
          class="clearer"
          v-if="customer1.updatedBy"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.updatedBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="updated">Date Updated:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.dateUpdated"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="lastActivity">Last Activity:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.lastContactDate"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="nextActivity">Next Activity:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="customer1.lastContactDate"
        ></InputText>
      </div>
    </div>
    
    <ContactForm
      :reload="reloadContactForm"
      :contactToEdit="contact"
      :contactForm="contactFormDialog"
      :disabledArr="contactDisabledArr"
      @hide-form-dialog=hideDialog
      @submit-contact-form=savedContact
    />

    <DuplicateDialog
      :key="duplicateDialogKey"
      :duplicateDialog="duplicateDialog"
      :contact="duplicateContact"
      @hide-duplicate-dialog=hideDuplicateDialog
      @submit-duplicate-form=saveDuplicate
    />

  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import ContactForm from '../../universalComponents/contact/contactForm'
import DuplicateDialog from '../../universalComponents/contact/duplicateDialog'

export default {
  props: ["customer"],
  components: {
    ContactForm,
    DuplicateDialog
  },
  data() {
    return {
      contactDisabledArr: [],
      contactFormDialog: false,
      reloadContactForm: 0,
      address: "",
      selectedContact: null,
      contacts: [],
      contactDialog: false,
      contact: {},
      customerN: null,
      custKC: {},
      lastOpened: null,
      customer1: {},
      duplicateDialogKey: 1000,
      duplicateToSend: {},
      duplicateContact: {},
      duplicateDialog: false,
      submitted: false
    };
  },
  customerService: null,
  created() {
    this.customer1 = {...this.customer}

    this.customerService = new CustomerService();
  },
  mounted() {

    document.getElementsByClassName('highlight')[0].addEventListener("click", () => {
      
      setTimeout(() => {
        let a = new Date().getTime() 
        if (!this.lastOpened || (this.lastOpened && a - this.lastOpened > 1000) ) {
          
          
          if (this.customer1.keyContact) {
            this.contact = {...this.customer1.keyContact}
            this.contactDisabledArr = [
              'keyContact',
              'notes',
              'country',
              'postCode',
              'address4',
              'address3',
              'address2',
              'address1',
              'Customer',
              'salutation',
              'lastName',
              'firstName'
            ]
            this.submitted = false
            this.contactFormDialog = true
          }
        }
      }, 500)
    }, true)
  },
  watch: {
    duplicateDialog(val) {
      this.duplicateDialogKey++
    },
    customer(val) {
      this.customer1 = {...val}
    },
    contactFormDialog(val) {
      this.reloadContactForm++
    }
  },
  methods: {
    async getCutomerInfo() {
      this.customer1 = await this.customerService.getCustomerInfo(
        this.$route.params.custid
      );
    },
    saveDuplicate() {
      this.duplicateDialog = false

      this.duplicateToSend.customer = this.$route.params.custid

      this.customerService
        .saveDuplicateContactDB(this.duplicateToSend)
        .then(response => {
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000,
            });

            this.getCutomerInfo()
          }
        })
        .catch(err => {
          
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving contact",
            life: 5000,
          })
        })
    },
    hideDuplicateDialog() {
      this.duplicateDialog = false
    },
    hideDialog() {
      this.contactFormDialog = false;
      this.submitted = false;
    },
    openModalContact() {
      this.lastOpened = new Date().getTime() 

      this.contact = {};
      if (this.customer1) {
        this.contact.customer = this.customer1
        this.contact.address1 = this.customer1.address1;
        this.contact.address2 = this.customer1.address2;
        this.contact.address3 = this.customer1.address3;
        this.contact.address4 = this.customer1.address4;
        this.contact.postCode = this.customer1.postCode;
        // this.contact.country = this.customer1.country;
      } else {
        this.contact.customerId = this.$route.params.custid
      }
      this.contact.canEmail = true;
      this.contact.canCall = true;
      this.contact.canMail = true;
      this.contact.active = true;
      if (this.contacts) {
        this.contact.keyContact = false;
      } else {
        this.contact.keyContact = true;
      }
      this.contactDisabledArr = [
        'Customer'
      ]
      this.submitted = false;
      this.contactFormDialog = true;
      this.reloadContactForm++
    },
    async toggle(event) {
      this.lastOpened = new Date().getTime() 

      this.$refs.op.toggle(event);
      this.contacts = await this.customerService.getCustomerContacts(
        this.$route.params.custid
      );
    },
    async updateContact() {
      if (this.selectedContact) {
        this.customer1.keyContact = this.selectedContact;
        this.contact = this.customer1.keyContact;
        this.customerService.updateCustomerContact(
          this.customer1.customerId,
          this.customer1.keyContact.contactId
        );
        this.toggle();
      }
    },
    onProductSelect(e) {
      
    },
    savedContact({ contact, duplicateContact, duplicateToSend }) {
      
      this.contact = {}
      this.contactFormDialog = false
      if (duplicateToSend) {
        this.duplicateToSend = duplicateToSend
        this.duplicateContact = duplicateContact
        this.duplicateDialog = true
      }

      this.getCutomerInfo()
    }
  },
};
</script>

<style scoped>
.highlight {
  text-decoration: underline;
  text-decoration-color: blue;
  text-underline-offset: 20px;
  text-decoration-thickness: 100px;
}

#keyContactFullName {
  cursor:pointer;
  color:blue;
  text-decoration:underline;

  height: 38px; 
  background-color: white; 
  border-color: #E5E5E5; 
  border-style: solid; 
  border-radius: 2px; 
}

#keyContactFullName:hover {
  text-decoration:none;
  /* text-shadow: 1px 1px 1px rgb(46, 43, 190); */

  background: linear-gradient(#4769ff, #4769ff) center bottom 5px /calc(100% - 10px) 1px no-repeat;
}

.highlight input.keyContactInput {
    width: 100%;
}
</style>